String.prototype.clearAllSpaces = function() {
  return this.replace(/\s/g, '');
};

String.prototype.clearThousandSeparator = function(s = '.') {
  return this.replaceAll(`${s}`, '');
};

String.prototype.clearEuroSymbol = function() {
  return this.replaceAll('€', '');
};

String.prototype.clearNonNumer = function() {
  return this.replace(/[^0-9]/g, '');
};

String.prototype.clearCurrencyChars = function() {
  return this.clearAllSpaces()
    .clearThousandSeparator()
    .clearEuroSymbol()
    .clearNonNumer();
};

String.prototype.currencyToInteger = function() {
  return parseInt(this.clearCurrencyChars());
};

String.prototype.currencyToFloat = function() {
  return parseFloat(this.clearCurrencyChars());
};

const numberToCurrency = function(val) {
  var formatter = new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0,
  });

  return formatter.format(val);
};

Number.prototype.toCurrencyFormat = function() {
  return numberToCurrency(this);
};

String.prototype.toCurrencyFormat = function() {
  return numberToCurrency(this * 1);
};
